<div class="tabMenubarPricepage">
  <div class="left-scroll-buttons-2">
    <div id="user_management_nav_scroll_left_button" (click)="scrollLeft()">
      <ng-icon name="tablerChevronLeft"></ng-icon>
    </div>
  </div>
  <div class="tab-container" id="scrollContainer1" (mouseenter)="onMouseEnter()" (mouseleave)="onMouseLeave()">
    <ng-container *ngFor="let tab of navBarList">
      <div id="user_management_nav_tab_{{tab.item}}" *ngIf="canShowMenu(tab)" [class.active]="selectedTab === tab.item" (click)="routeTo(tab)"
        class="tab">
        <ng-icon name="tablerCrown" *ngIf="tab.item === 'plan'" class="svg-position"></ng-icon>
        <ng-icon name="tablerNetwork" *ngIf="tab.item === 'network'" class="svg-position"></ng-icon>
        <ng-icon name="tablerChartBar" *ngIf="tab.item === 'analytics'" class="svg-position"></ng-icon>
        <ng-icon name="tablerHandClick" *ngIf="tab.item === 'interaction'" class="svg-position"></ng-icon>
        <ng-icon name="tablerId" *ngIf="tab.item === 'businessContacts'" class="svg-position"></ng-icon>
        <ng-icon name="tablerId" *ngIf="tab.item === 'contacts'" class="svg-position"></ng-icon>
        <ng-icon name="tablerSitemap" *ngIf="tab.item === 'businessNetworks'" class="svg-position"></ng-icon>
        <ng-icon name="tablerBriefcase" *ngIf="tab.item === 'jobs'" class="svg-position"></ng-icon>
        <ng-icon name="tablerLayoutGrid" *ngIf="tab.item === 'workSpace'" class="svg-position"></ng-icon>
        <ng-icon name="tablerUsers" *ngIf="tab.item === 'user'" class="svg-position"></ng-icon>
        <ng-icon name="tablerFileInvoice" *ngIf="tab.item === 'billing'" class="svg-position"></ng-icon>
        <ng-icon name="tablerBell" *ngIf="tab.item === 'notification'" class="svg-position"></ng-icon>
        <ng-icon name="tablerCreditCard" *ngIf="tab.item === 'credit'" class="svg-position"></ng-icon>
        <ng-icon name="tablerShare" *ngIf="tab.item === 'referral'" class="svg-position"></ng-icon>
        <ng-icon name="tablerSettings" *ngIf="tab.item === 'settings'" class="svg-position"></ng-icon>
        <ng-icon name="tablerSettings" *ngIf="tab.item === 'publishSettings'" class="svg-position"></ng-icon>
        <ng-icon name="tablerLock" *ngIf="tab.item === 'appAccess'" class="svg-position"></ng-icon>
        <ng-icon name="tablerBriefcase" *ngIf="tab.item === 'businessJob'" class="svg-position"></ng-icon>
        <ng-icon name="tablerUserCheck" *ngIf="tab.item === 'businessCandidate'" class="svg-position"></ng-icon>
        <ng-icon name="tablerUserPlus" *ngIf="tab.item === 'businessApplicants'" class="svg-position"></ng-icon>
        {{ tab.name }}
      </div>
    </ng-container>
  </div>
  <div class="right-scroll-buttons-2">
    <div id="user_management_nav_scroll_right_button" (click)="scrollRight()">
      <ng-icon name="tablerChevronRight"></ng-icon>
    </div>
  </div>
</div>